<template>
  <b-card no-body class="mb-5">
    <b-card-header class="border-0" v-if="cabecera">
      <b-row>
        <b-col>
          <h3 class="mb-0 mr-2">Activar filtros</h3>
          <el-switch v-model="filtros.status" />
        </b-col>
        <b-col>
          <el-checkbox
            :disabled="!filtros.status"
            v-model="filtros.bautizado"
            label="Bautizado"
            size="large"
          />
          <el-switch
            class="ml-2"
            :disabled="!filtros.status"
            v-model="filtros.bautizadoStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </b-col>

        <!-- <div class="separador ml-2 mr-2"></div> -->
        <b-col>
          <el-checkbox
            v-model="filtros.foto"
            :disabled="!filtros.status"
            label="Foto"
            size="large"
          />
          <el-switch
            class="ml-2"
            :disabled="!filtros.status"
            v-model="filtros.fotoStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </b-col>
        <b-col>
          <base-input
            type="text"
            label="Buscar"
            placeholder="Buscar"
            v-model="filtros.buscadorText"
          />
        </b-col>

        <div class="separador ml-2 mr-2"></div>
        <b-col>
          <b-row v-if="listas">
            <b-button
              type="submit"
              variant="primary"
              class="mt-3"
              @click="bajaLista(1)"
              >Lista completas</b-button
            >
            <b-button
              type="submit"
              variant="primary"
              class="mt-3"
              @click="bajaLista(2)"
              >Lista Simples</b-button
            >
            <b-button
              type="submit"
              variant="primary"
              class="mt-3"
              @click="visibleAsistencia = !visibleAsistencia"
              >{{
                visibleAsistencia ? "Lista Catecumenos" : "Lista de asistencia"
              }}
            </b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-card-header>
    <b-row v-if="visibleAsistencia">
      <div class="container mt-4">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Nombre del Alumno</th>
              <th v-for="(fecha, index) in fechas" :key="index">{{ fecha }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(alumno, index) in alumnos" :key="index">
              <td>{{ alumno.nombre }}</td>
              <td v-for="(fecha, idx) in fechas" :key="idx" class="text-center">
                <input
                  v-if="
                    alumno.asistencia[fecha] == true ||
                    alumno.asistencia[fecha] == false
                  "
                  type="checkbox"
                  v-model="alumno.asistencia[fecha]"
                />
                <p v-else></p>
              </td>
            </tr>
          </tbody>
        </table>
        <button class="btn btn-primary mt-3" @click="agregarFecha">
          Agregar Día
        </button>
        <button class="btn btn-primary mt-3" @click="guardarCambios">
          Guardar cambios
        </button>
      </div>
    </b-row>
    <b-row class="m-1" v-else-if="!visibleAsistencia">
      <b-col>
        <el-table
          v-if="datosCatecumenos.length > 0"
          class="table-responsive table"
          header-row-class-name="thead-light"
          :data="paginatedData"
          @row-click="elementSelected"
        >
          <el-table-column
            label="Nombre"
            min-width="290px"
            sortable
            :sort-method="
              genericSort([
                'padre.nombre',
                'padre.apellido1',
                'padre.apellido2',
              ])
            "
          >
            <template v-slot="{ row }">
              <span class="font-weight-600 name mb-0 text-sm">
                {{ row.apellido1 + " " + row.apellido2 + ", " + row.nombre }}
              </span>
            </template>
          </el-table-column>
          <el-table-column sortable label="Nacimiento" min-width="170px">
            <template v-slot="{ row }">
              <span class="font-weight-600 name mb-0 text-sm">{{
                formateaFecha(row.fecha_nacimiento)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="Años" min-width="95px">
            <template v-slot="{ row }">
              <span class="font-weight-600 name mb-0 text-sm">{{
                calculaEdad(row.fecha_nacimiento)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="Padre" min-width="250px">
            <template v-slot="{ row }">
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.id_padre
                  ? row.padre.nombre +
                    " " +
                    row.padre.apellido1 +
                    " " +
                    row.padre.apellido2
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="Tlf.Padre" min-width="130px">
            <template v-slot="{ row }">
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.id_padre ? row.padre.telefono : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="Madre" min-width="250px">
            <template v-slot="{ row }">
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.id_madre
                  ? row.madre.nombre +
                    " " +
                    row.madre.apellido1 +
                    " " +
                    row.madre.apellido2
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="TLF.Madre" min-width="130px">
            <template v-slot="{ row }">
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.id_madre ? row.madre.telefono : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="Bautizo" min-width="120px">
            <template v-slot="{ row }">
              <span
                v-if="checkBautizo(row.bautizo)"
                class="alert-icon"
                style="color: green"
                ><i class="ni ni-like-2"></i
              ></span>
              <span
                v-else
                class="alert-icon"
                style="transform: rotate(181deg); color: red"
                ><i class="ni ni-like-2"></i
              ></span>
            </template>
          </el-table-column>
          <el-table-column sortable label="Foto" min-width="100px">
            <template v-slot="{ row }">
              <span
                v-if="row.nombreFoto"
                class="alert-icon"
                style="color: green"
                ><i class="ni ni-like-2"></i
              ></span>
              <span
                v-else
                class="alert-icon"
                style="transform: rotate(181deg); color: red"
                ><i class="ni ni-like-2"></i
              ></span>
            </template>
          </el-table-column>
          <el-table-column v-if="editable" label="Editar" min-width="120px">
            <template v-slot="{ row }">
              <b-col>
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  @click="editarElemento(row)"
                ></el-button>
              </b-col>
              <b-col>
                <el-button
                  type="primary"
                  icon="el-icon-delete"
                  circle
                  @click="
                    eliminarElemento(
                      row.id,
                      row.nombre + ' ' + row.apellido1 + ' ' + row.apellido2
                    )
                  "
                ></el-button>
              </b-col>
            </template>
          </el-table-column>
        </el-table>
        <!-- Paginación -->
        <el-pagination
          style="text-align: center"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[5, 10, 15, 20, 50, 100]"
          :background="false"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import axios from "@/directives/axios.js";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  name: "tabla-grupos",
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      totalItems: 0,
      options: [
        { value: 0, text: "No" },
        { value: 1, text: "Si" },
      ],
      visibleAsistencia: false,
      baseApi: location.protocol + "//" + location.hostname,
      filtros: {
        status: false,
        bautizado: false,
        bautizadoStatus: false,
        foto: false,
        fotoStatus: false,
        buscadorText: "",
      },
      datosCatecumenosCopia: [],
      fechas: [],
      alumnos: [],
    };
  },
  props: {
    editable: { type: Boolean, default: false },
    cabecera: { type: Boolean, default: false },
    listas: { type: Boolean, default: false },
    datos: { type: [Array, Object], default: undefined },
    asistencia: { type: String },
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.datosCatecumenosCopia.slice(start, end);
    },
    datosCatecumenos: {
      get() {
        let datosTabla = [];
        let datosCate = [];
        datosCate = this.datos;
        if (!this.datos) {
          return [];
        } else {
          if (Array.isArray(datosCate)) {
            datosTabla = [...datosCate].sort((a, b) => {
              if (a.apellido1 > b.apellido1) return 1;
              if (a.apellido1 < b.apellido1) return -1;
              return 0;
            });
          } else {
            datosTabla = [...datosCate.catecumenos].sort((a, b) => {
              if (a.apellido1 > b.apellido1) return 1;
              if (a.apellido1 < b.apellido1) return -1;
              return 0;
            });
          }

          if (this.listas) {
            this.cargaListaAsistencia(datosTabla);
          }
          this.datosCatecumenosCopia = datosTabla;
          this.totalItems = datosTabla.length;
          return datosTabla;
        }
      },
      set(value) {
        return value;
      },
    },
  },
  methods: {
    cargaListaAsistencia(datosTabla) {
      this.fechas = [];
      this.alumnos = [];
      // Comprobamos si 'asistencia' está en formato JSON y lo asignamos si existe
      if (this.datos.asistencia) {
        const asistenciaParsed = JSON.parse(this.datos.asistencia);
        if (
          asistenciaParsed &&
          asistenciaParsed.asistencia &&
          asistenciaParsed.asistencia.length > 0
        ) {
          this.alumnos = asistenciaParsed.asistencia;
        }
        if (asistenciaParsed && asistenciaParsed.fechas) {
          this.fechas = asistenciaParsed.fechas;
        }
      }

      var alumnos2 = [];

      // Verificamos si la longitud de alumnos es diferente y si hay elementos en alumnos
      if (this.alumnos.length != datosTabla.length && this.alumnos.length > 0) {
        datosTabla.forEach((element) => {
          var catecumenosSelect = this.alumnos.find(
            (catecumen) => catecumen.id == element.id
          );

          // Si el catecúmeno no está seleccionado, lo añadimos al array de alumnos2
          if (!catecumenosSelect) {
            alumnos2.push({
              nombre:
                element.apellido1 +
                " " +
                element.apellido2 +
                ", " +
                element.nombre,
              asistencia: {}, // Puedes inicializar la asistencia como desees
              id: element.id,
            });
          }
        });

        // Importante: crear un nuevo array en lugar de mutar el existente
        this.alumnos = [...this.alumnos, ...alumnos2];
      } else if (
        this.alumnos.length != datosTabla.length &&
        this.alumnos.length == 0
      ) {
        // Asignamos una nueva copia a this.alumnos en lugar de mutarla directamente
        this.alumnos = datosTabla.map((element) => {
          return {
            nombre:
              element.apellido1 +
              " " +
              element.apellido2 +
              ", " +
              element.nombre,
            asistencia: {},
            id: element.id,
          };
        });
      }
    },
    elementSelected(element) {
      console.log("click-Catecumeno");
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1; // Reiniciar la página actual cuando se cambia el tamaño
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    checkBautizo(value) {
      try {
        if (value) {
          var element = JSON.parse(value);
          if (element.entregada && element.entregada == 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    guardarCambios() {
      var data = { asistencia: this.alumnos, fechas: this.fechas };
      var request = JSON.stringify(data);
      this.$emit("guardaAsistencia", this.datos.id, request);
      //Pasa el dato de asistencia a JSON "String";
    },
    agregarFecha() {
      const hoy = new Date().toLocaleDateString();
      if (!this.fechas.includes(hoy)) {
        this.fechas.push(hoy);
        this.alumnos.forEach((alumno) => {
          this.$set(alumno.asistencia, hoy, false);
        });
      }
    },
    bajaLista(valueList) {
      loader.open();
      if (this.datos.catecumenos.length > 0) {
        var parametros;
        this.$store.getters.getCursosGruposNum.forEach((element) => {
          element.grupos.forEach((element2) => {
            if (element2.id == this.datos.id) {
              parametros = {
                catequistas: element2.catequistas
                  .map((element3) => {
                    let value =
                      (element3.nombre !== "" ? element3.nombre : "") +
                      (element3.apellido1 !== ""
                        ? " " + element3.apellido1
                        : "") +
                      (element3.apellido2 !== ""
                        ? " " + element3.apellido2
                        : "");
                    return value !== "" ? value : null; // Devolvemos null si no hay valor
                  })
                  .filter((value) => value !== null) // Filtramos valores vacíos o null
                  .join(", "), // Usamos join para separar los valores correctamente

                nombreGrupo: element2.nombre_grupo ? element2.nombre_grupo : "",
                nombreCurso: element.nombre ? element.nombre : "",
                aula: element.nombre_clase ? element.nombre_clase : "",
                aniocomunion: this.calculaAniocomunion(),
              };
            }
          });
        });
        axios({
          method: "post",
          url: `/catecumenos/exportpdfs`,
          responseType: "blob",
          withCredentials: true,
          data: {
            lista: valueList,
            idGrupo: this.datos.id,
            parametros: parametros,
          },
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "reporte.pdf");
            swal.hideLoading();
            document.body.appendChild(link);
            loader.close();
            link.click();
            document.body.removeChild(link);
          })
          .catch(() => {
            loader.close();
          });
      } else {
        loader.close();
        swal.fire({
          text: `No se encuentran datos para imprimir`,
          icon: "info",
          confirmButtonText: "Aceptar",
        });
      }
    },
    calculaAniocomunion() {
      var fecha = new Date();
      var anio = fecha.getFullYear();
      var mes = fecha.getDate();
      if (mes > 8) {
        return anio + "/" + (anio + 1);
      } else {
        return anio - 1 + "/" + anio;
      }
    },
    editarElemento(element) {
      this.$emit("editarElemento", element);
    },
    formateaFecha(data) {
      if (data != undefined && data != null) {
        return data.split("-").reverse().toString().replaceAll(",", "-");
      } else {
        return "";
      }
    },
    calculaEdad(data) {
      let fechaNac = new Date(data);
      // Obtener la fecha actual
      let hoy = new Date();
      // Calcular la diferencia en años
      let edad = hoy.getFullYear() - fechaNac.getFullYear();
      // Ajustar si el cumpleaños no ha ocurrido este año
      let mes = hoy.getMonth() - fechaNac.getMonth();
      if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
        edad--;
      }

      return edad;
    },
    eliminarElemento(id, nombre) {
      swal
        .fire({
          text: `¿Esta Seguro de que desea eliminar a ${nombre}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f5365c",
          cancelButtonColor: "#616365",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.$emit("eliminarElemento", id);
          }
        });
    },
    genericSort(keys) {
      return (a, b) => {
        const valueA = this.getConcatenatedValues(a, keys);
        const valueB = this.getConcatenatedValues(b, keys);
        return valueA.localeCompare(valueB);
      };
    },
    getConcatenatedValues(object, keys) {
      return keys
        .map((key) => key.split(".").reduce((o, i) => o[i], object))
        .join(" ");
    },
    filtrarPorTexto(lista, textoBusqueda) {
      // Normalizamos el texto de búsqueda
      const textoNormalizado = this.normalizarTexto(textoBusqueda);

      // Filtramos la lista comparando el nombre y apellidos de cada persona
      return lista.filter((persona) => {
        const nombreCompleto = `${persona.nombre} ${persona.apellido1} ${persona.apellido2}`;

        // Normalizamos el nombre completo y verificamos si contiene el texto de búsqueda
        return this.normalizarTexto(nombreCompleto).includes(textoNormalizado);
      });
    },
    normalizarTexto(texto) {
      return texto
        .toLowerCase() // Convertimos todo a minúsculas
        .normalize("NFD") // Descomponemos los caracteres con tilde
        .replace(/[\u0300-\u036f]/g, ""); // Eliminamos los acentos
    },
  },
  watch: {
    filtros: {
      handler(newValue) {
        this.datosCatecumenosCopia = this.datosCatecumenos;
        if (this.filtros.status) {
          if (newValue.bautizado && newValue.bautizadoStatus) {
            this.datosCatecumenosCopia = this.datosCatecumenosCopia.filter(
              (element) => element.bautizo != null
            );
          }
          if (newValue.bautizado && !newValue.bautizadoStatus) {
            this.datosCatecumenosCopia = this.datosCatecumenosCopia.filter(
              (element) => element.bautizo == null
            );
          }
          if (newValue.foto && newValue.fotoStatus) {
            this.datosCatecumenosCopia = this.datosCatecumenosCopia.filter(
              (element) => element.nombreFoto != null
            );
          }
          if (newValue.foto && !newValue.fotoStatus) {
            this.datosCatecumenosCopia = this.datosCatecumenosCopia.filter(
              (element) => element.nombreFoto == null
            );
          }
          let datos = this.filtrarPorTexto(
            this.datosCatecumenosCopia,
            this.filtros.buscadorText
          );
          if (Array.isArray(datos)) {
            this.datosCatecumenosCopia = [...datos].sort((a, b) => {
              return a.apellido1.localeCompare(b.apellido1, "es", {
                sensitivity: "base",
              });
            });
          } else {
            this.datosCatecumenosCopia = datos;
          }
        }
        this.totalItems = this.datosCatecumenosCopia.length;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.separador {
  border-left: 1px solid rgb(2, 2, 2);
  height: auto;
}

.table th,
.table td {
  vertical-align: middle;
}
</style>
